import { warName } from "../..";
import { getEnv } from "../env";
import { getQueryStringVariable } from "./getQueryStringVariable";

export function loadSystemCode(apiDomain) {
	let systemCode = window.xs_systemCode || window.cg_SYSTEM_CODE || window.appConfig?.SYSTEM_CODE;
	const systemCodeFromQueryString = getQueryStringVariable("system_code") || getQueryStringVariable("systemCode");
	
	/*if (!systemCode) {
		systemCode = getQueryStringVariable("system_code");		
	}
	if (!systemCode) {
		systemCode = getQueryStringVariable("systemCode");		
	}*/
	if(systemCodeFromQueryString) {
		systemCode = systemCodeFromQueryString;
	}
	
	if (!systemCode || getEnv('REACT_APP_FORCE_LOAD_SYSCODE_FROM_DOMAIN')) {
		// pure javascript, to avoid jquery loading
		const xhr = new window.XMLHttpRequest();
		// false in the last parameter means "synchronous"
		xhr.open('GET', apiDomain + '/'+ warName + '/getSystemCodeFromDomain', false);
		xhr.send();
		if (xhr.status === 200) {
			systemCode = xhr.responseText;
		}
	}
	
	return systemCode === '' ? null: systemCode;
}
